import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { userStatus } from '../userLogin/saga';
import { checkUserHelper } from '../utils/helperSagas';
import { UPDATE_ACCOUNT_DETAILS } from './actionTypes';
import { updateAccountDetailsDone, updateAccountDetailsError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* updateAccountDetailsCall(constAccessParams, action) {
    const { first_name, last_name, gender, date_of_birth } = action.data;
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    if (first_name && last_name) {
        const result = yield call(HeroAccountAPI.setFirstLastName, newAccessParams, first_name, last_name, gender, date_of_birth);
        if (isSuccessResponse(result)) {
            yield call(userStatus, newAccessParams);
            yield put(updateAccountDetailsDone({ first_name, last_name, gender, date_of_birth }));
        }
        else if (result.statusCode === 4) {
            yield put(logout());
        }
        else {
            yield put(updateAccountDetailsError(result));
        }
    }
}
export function* watchUpdateAccountDetailsCall(constAccessParams) {
    yield takeLatest(UPDATE_ACCOUNT_DETAILS, updateAccountDetailsCall, constAccessParams);
}
//# sourceMappingURL=saga.js.map